export default __webpack_public_path__ + "static/media/check_mark.d23bd2f1.svg";